import { Audit } from "../../domain/model/audit.model";
import { IApiAudit } from "../interfaces/audit-api.interface";


export class AuditMapper {


  static toApi(audit: Audit): IApiAudit | null {
    if (!audit) {
      return null;
    }

    return {
        _id: audit._id,
        organizationId: audit.organizationId,
        serviceId: audit.serviceId,
        accountId: audit.accountId,
        body: audit.body,
        createdAt: audit.createdAt,
        createdBy: audit.createdBy,
        updatedAt: audit.updatedAt,
        updatedBy: audit.updatedBy,
        removedAt: audit.removedAt,
        removedBy: audit.removedBy,
      };
  }
}